import React, { ReactNode } from 'react';
import { HeadlineInfo } from './HeadlineInfo';
import { GetHeadlineAndPosition, HeadlineType } from '../BlockInteractionsTypes';

type BlockInteractionsInfoType = {
  isNestedInCollapsibleOrLayoutGroup?: boolean;
  headline: HeadlineType;
  headingRef: React.RefObject<HTMLHeadingElement | null>;
  info?: ReactNode;
  getHeadlinePosition: GetHeadlineAndPosition;
};

export function BlockInteractionsInfo({
  isNestedInCollapsibleOrLayoutGroup,
  headline,
  headingRef,
  info,
  getHeadlinePosition,
}: BlockInteractionsInfoType) {
  return (
    <div className="block-interactions__info">
      <HeadlineInfo
        isNestedInCollapsibleOrLayoutGroup={isNestedInCollapsibleOrLayoutGroup}
        headline={headline}
        headingRef={headingRef}
        info={info}
        getHeadlinePosition={getHeadlinePosition}
      />
    </div>
  );
}
